import React from 'react';
import { useTranslation } from 'react-i18next';

import { Alert, BodyText } from '@chargify/custom-ui-components';
import { ChangePlanPreview } from '../../machines/changePlan';

type Props = {
  productChangeStrategy: ChangePlanPreview['productChangeStrategy'];
  nextBillingDate: string;
  basePlanPrice: string;
  totalCharge: string;
  creditBalance: string;
};
export const PlanChangeAlerts = ({
  basePlanPrice,
  productChangeStrategy,
  nextBillingDate,
  totalCharge,
  creditBalance,
}: Props) => {
  const { t } = useTranslation(['subscriptions-manager']);

  const commonAlertProps = {
    color: 'success',
    icon: 'receipt',
  } as const;

  switch (productChangeStrategy) {
    case 'prorated':
      return (
        <Alert {...commonAlertProps}>
          <Alert.Title
            text={t('plan_change.prorated_title', {
              totalCharge: totalCharge,
              credit: creditBalance,
            })}
            icon={'receipt'}
          />
          <Alert.Title
            text={t('plan_change.plan_change_immediately')}
            icon={'clock'}
          />
          <Alert.Title
            text={t('plan_change.prorated_renewed_title', {
              date: nextBillingDate,
            })}
            icon={'calendar'}
          />
          <BodyText variant={'body2'} color={'success.main'}>
            {t('plan_change.prorated_description')}
          </BodyText>
        </Alert>
      );
    case 'non-prorated':
      return (
        <Alert {...commonAlertProps}>
          <Alert.Title
            text={t('plan_change.instant_title', {
              totalCharge: totalCharge,
            })}
            icon={'receipt'}
          />
          <Alert.Title
            text={t('plan_change.plan_change_immediately')}
            icon={'clock'}
          />
          <BodyText variant={'body2'} color={'success.main'}>
            {t('plan_change.instant_description')}
          </BodyText>
        </Alert>
      );
    case 'delayed':
      return (
        <Alert
          {...commonAlertProps}
          title={t('plan_change.delayed_title', {
            date: nextBillingDate,
            basePlanPrice,
          })}
        >
          <BodyText variant={'body2'} color={'success.main'}>
            {t('plan_change.delayed_description')}
          </BodyText>
        </Alert>
      );
  }
};
